export default __webpack_public_path__ + "static/media/led_media1.f011fdee.png";